import _objectWithoutProperties from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _defineProperty from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var _excluded = ["id", "iconName", "imageUrl"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { isBoolean } from 'lodash';
import { BROKER_DEFAULT_EMAIL_HEADER_BANNER_IMAGE_URL } from '../../constants';
import { truelyValueMap } from '../../constants/common';
export var convertLocalTripartiteCooperationGeneralSettingDataToServerStructureData = function convertLocalTripartiteCooperationGeneralSettingDataToServerStructureData(data, config) {
  var name = data.name,
      slug = data.slug,
      platform = data.platform,
      firstName = data.firstName,
      lastName = data.lastName,
      email = data.email,
      website = data.website,
      country = data.country,
      jobTitle = data.jobTitle,
      phone = data.phone,
      brokerCommission = data.brokerCommission,
      brokerCommissionUnit = data.brokerCommissionUnit,
      brokerFee = data.brokerFee,
      brokerFeeUnit = data.brokerFeeUnit,
      brokerFeeCap = data.brokerFeeCap,
      underwritingFee = data.underwritingFee,
      underwritingFeeUnit = data.underwritingFeeUnit,
      underwritingFeeCap = data.underwritingFeeCap,
      assignee = data.assignee,
      allowSubBrokerQuote = data.allowSubBrokerQuote,
      allowSubBrokerUpdateBranding = data.allowSubBrokerUpdateBranding,
      disallowViewSubBrokersInPortal = data.disallowViewSubBrokersInPortal,
      exclusiveQuoteRights = data.exclusiveQuoteRights,
      autoApproveLegalEntity = data.autoApproveLegalEntity,
      hidePortalHomeJoveLogo = data.hidePortalHomeJoveLogo,
      enableTwoFactorAuthentication = data.enableTwoFactorAuthentication,
      showPartnersInPortal = data.showPartnersInPortal,
      allowAddR2RProducts = data.allowAddR2RProducts,
      payload = data.payload,
      activationManager = data.activationManager,
      accountingFirstName = data.accountingFirstName,
      accountingLastName = data.accountingLastName,
      accountingPhone = data.accountingPhone,
      accountingEmail = data.accountingEmail,
      brokerType = data.brokerType,
      paymentProcessingBusinessName = data.paymentProcessingBusinessName,
      paymentProcessingIBANOrAccountNumber = data.paymentProcessingIBANOrAccountNumber,
      paymentProcessingSortCode = data.paymentProcessingSortCode,
      paymentProcessingFullAddress = data.paymentProcessingFullAddress;
  var params = {
    name: name,
    slug: slug === null || slug === void 0 ? void 0 : slug.trim(),
    contact_first_name: firstName,
    contact_last_name: lastName,
    email: email,
    website: website,
    type: config === null || config === void 0 ? void 0 : config.source,
    country_id: country === null || country === void 0 ? void 0 : country.id,
    job_title: jobTitle,
    phone: phone,
    sourceType: config === null || config === void 0 ? void 0 : config.source,
    broker_commission_fee: brokerCommission,
    broker_commission_fee_type: brokerCommissionUnit,
    broker_fee: brokerFee,
    broker_fee_type: brokerFeeUnit,
    broker_fee_cap: brokerFeeCap,
    broker_underwriting_fee: underwritingFee,
    broker_underwriting_fee_type: underwritingFeeUnit,
    broker_underwriting_fee_cap: underwritingFeeCap,
    broker_platform: platform || null,
    assignee_id: (assignee === null || assignee === void 0 ? void 0 : assignee.value) || null,
    payload: _objectSpread(_objectSpread({}, payload), {}, {
      broker_type: brokerType,
      header_settings: _objectSpread(_objectSpread({}, payload === null || payload === void 0 ? void 0 : payload.header_settings), {}, {
        custom_image_url: BROKER_DEFAULT_EMAIL_HEADER_BANNER_IMAGE_URL
      }),
      sub_broker_settings: _objectSpread(_objectSpread({}, payload === null || payload === void 0 ? void 0 : payload.sub_broker_settings), {}, {
        allow_update_quote_payment: allowSubBrokerQuote,
        allow_update_website_files: allowSubBrokerUpdateBranding,
        disallow_view_sub_brokers_in_portal: disallowViewSubBrokersInPortal,
        exclusive_quote_rights: exclusiveQuoteRights,
        auto_approve_legal_entity: autoApproveLegalEntity
      }),
      portal_settings: _objectSpread(_objectSpread({}, payload === null || payload === void 0 ? void 0 : payload.portal_settings), {}, {
        hide_jove_logo_in_portal_homepage: hidePortalHomeJoveLogo,
        enable_two_factor_authentication: enableTwoFactorAuthentication,
        show_partners_in_portal: showPartnersInPortal
      }),
      product_settings: _objectSpread(_objectSpread({}, payload === null || payload === void 0 ? void 0 : payload.product_settings), {}, {
        allow_r2r: allowAddR2RProducts
      }),
      accounting_settings: _objectSpread(_objectSpread({}, payload === null || payload === void 0 ? void 0 : payload.accounting_settings), {}, {
        accounting_first_name: accountingFirstName || '',
        accounting_last_name: accountingLastName || '',
        accounting_phone: accountingPhone || '',
        accounting_email: accountingEmail || ''
      }),
      payment_processing_info: _objectSpread(_objectSpread({}, payload === null || payload === void 0 ? void 0 : payload.payment_processing_info), {}, {
        business_name: paymentProcessingBusinessName || '',
        iban_or_account_number: paymentProcessingIBANOrAccountNumber || '',
        sort_code: paymentProcessingSortCode || '',
        full_address: paymentProcessingFullAddress || ''
      })
    }),
    activation_manager: (activationManager === null || activationManager === void 0 ? void 0 : activationManager.value) || null
  };
  return params;
};
export var convertLocalTripartiteCooperationWebsiteConfigurationDataToServerStructureData = function convertLocalTripartiteCooperationWebsiteConfigurationDataToServerStructureData(data, config) {
  var footerDisplayType = data.footerDisplayType,
      introductionList = data.introductionList,
      socialMediaList = data.socialMediaList,
      copyrightText = data.copyrightText,
      companyFullName = data.companyFullName,
      registeredAddress = data.registeredAddress,
      registeredNumber = data.registeredNumber,
      hideLandingPageHeader = data.hideLandingPageHeader,
      landingPageHeaderLogoHeight = data.landingPageHeaderLogoHeight,
      landingPageHeaderQuoteButtonText = data.landingPageHeaderQuoteButtonText,
      landingPageHeaderQuoteButtonFontSize = data.landingPageHeaderQuoteButtonFontSize,
      landingPageHeaderQuoteButtonTextColor = data.landingPageHeaderQuoteButtonTextColor,
      landingPageHeaderQuoteButtonBGColor = data.landingPageHeaderQuoteButtonBGColor,
      partnerStatementEnabled = data.partnerStatementEnabled,
      partnerStatementDefaultExpanded = data.partnerStatementDefaultExpanded,
      partnerStatementTitle = data.partnerStatementTitle,
      partnerStatementParagraphList = data.partnerStatementParagraphList,
      partnerStatementBackgroundColor = data.partnerStatementBackgroundColor,
      partnerStatementTextColor = data.partnerStatementTextColor,
      partnerStatementFontSize = data.partnerStatementFontSize,
      customersSayTitle = data.customersSayTitle,
      customersSayContent = data.customersSayContent,
      customersSayCustomerName = data.customersSayCustomerName,
      customersSayCustomerJobTitle = data.customersSayCustomerJobTitle,
      customersSayCustomerCompanyName = data.customersSayCustomerCompanyName,
      hideTestimonial = data.hideTestimonial,
      termsAndConditionsFile = data.termsAndConditionsFile,
      termsAndConditionsUploadType = data.termsAndConditionsUploadType,
      termsAndConditionsCustomUrl = data.termsAndConditionsCustomUrl,
      privacyPolicyFile = data.privacyPolicyFile,
      privacyPolicyUploadType = data.privacyPolicyUploadType,
      privacyPolicyCustomUrl = data.privacyPolicyCustomUrl,
      hideLandingPageFooter = data.hideLandingPageFooter,
      landingPageFooterEntityCountries = data.landingPageFooterEntityCountries;
  return {
    website_configuration: {
      footer: footerDisplayType,
      legal_term: introductionList.map(function (item) {
        delete item.id;
        return item;
      }),
      social_media: socialMediaList.map(function (item) {
        delete item.id;
        return item;
      }),
      additional_information: {
        copyright: copyrightText || '',
        company_info: companyFullName || '',
        registered_address: registeredAddress || '',
        registerd_number: registeredNumber || ''
      },
      header_information: {
        hide_header: !!hideLandingPageHeader,
        logo_height: landingPageHeaderLogoHeight,
        quote_button_text: landingPageHeaderQuoteButtonText,
        quote_button_font_size: landingPageHeaderQuoteButtonFontSize,
        quote_button_text_color: landingPageHeaderQuoteButtonTextColor,
        quote_button_bg_color: landingPageHeaderQuoteButtonBGColor
      },
      partner_statement: {
        enabled: !!partnerStatementEnabled,
        default_expanded: isBoolean(partnerStatementDefaultExpanded) ? partnerStatementDefaultExpanded : true,
        title: partnerStatementTitle,
        paragraph_list: (partnerStatementParagraphList || []).map(function (item) {
          return {
            text: (item === null || item === void 0 ? void 0 : item.text) || ''
          };
        }).filter(function (item) {
          return !!item.text;
        }),
        background_color: partnerStatementBackgroundColor,
        text_color: partnerStatementTextColor,
        font_size: partnerStatementFontSize
      },
      testimonial: {
        title: customersSayTitle,
        hide_testimonial: !!hideTestimonial,
        info_list: [{
          content: customersSayContent,
          name: customersSayCustomerName,
          job_title: customersSayCustomerJobTitle,
          company_name: customersSayCustomerCompanyName
        }]
      },
      quote_terms_document: _objectSpread(_objectSpread({}, termsAndConditionsFile), {}, {
        revision_type: termsAndConditionsUploadType,
        file_url: termsAndConditionsCustomUrl
      }),
      privacy_policy_document: _objectSpread(_objectSpread({}, privacyPolicyFile), {}, {
        revision_type: privacyPolicyUploadType,
        file_url: privacyPolicyCustomUrl
      }),
      footer_information: {
        hide_footer: !!hideLandingPageFooter,
        entity_countries: landingPageFooterEntityCountries
      }
    }
  };
};
export var convertLocalTripartiteCooperationEmailSettingsDataToServerStructureData = function convertLocalTripartiteCooperationEmailSettingsDataToServerStructureData(data, config) {
  var dropoutBeforeQuotedFormLandingPage = data.dropoutBeforeQuotedFormLandingPage,
      dropoutBeforePurchaseFormLandingPage = data.dropoutBeforePurchaseFormLandingPage,
      otherStatusFormLandingPage = data.otherStatusFormLandingPage,
      purchasedLandingPage = data.purchasedLandingPage,
      dropoutBeforeQuotedFormBrokerPortal = data.dropoutBeforeQuotedFormBrokerPortal,
      dropoutBeforePurchaseFormBrokerPortal = data.dropoutBeforePurchaseFormBrokerPortal,
      otherStatusFormBrokerPortal = data.otherStatusFormBrokerPortal,
      purchasedBrokerPortal = data.purchasedBrokerPortal,
      disablePolicyEmails = data.disablePolicyEmails,
      referralRelatedEmail = data.referralRelatedEmail,
      senderEmail = data.senderEmail,
      replyEmail = data.replyEmail,
      senderName = data.senderName,
      emailOfficialWebsite = data.emailOfficialWebsite,
      emailBookMeetingAddress = data.emailBookMeetingAddress,
      emailContactEmailAddress = data.emailContactEmailAddress,
      emailContactPhoneNumber = data.emailContactPhoneNumber,
      emailButtonPrimaryBackgroundColor = data.emailButtonPrimaryBackgroundColor,
      emailButtonPrimaryTextColor = data.emailButtonPrimaryTextColor,
      emailHeaderBackgroundImage = data.emailHeaderBackgroundImage;
  return {
    quote_email_settings: {
      quotes_from_landing_page: {
        dropout_before_quoted: dropoutBeforeQuotedFormLandingPage,
        dropout_before_purchase: dropoutBeforePurchaseFormLandingPage,
        others: otherStatusFormLandingPage,
        purchased: purchasedLandingPage
      },
      quotes_from_broker_portal: {
        dropout_before_quoted: dropoutBeforeQuotedFormBrokerPortal,
        dropout_before_purchase: dropoutBeforePurchaseFormBrokerPortal,
        others: otherStatusFormBrokerPortal,
        purchased: purchasedBrokerPortal
      },
      policy_email_settings: {
        disable_policy_emails: disablePolicyEmails
      },
      referral_email_settings: {
        referral_related_email: referralRelatedEmail
      },
      sender_email: senderEmail,
      reply_email: replyEmail,
      sender_name: senderName
    },
    button_settings: {
      primary_bg_color: emailButtonPrimaryBackgroundColor,
      primary_text_color: emailButtonPrimaryTextColor
    },
    header_settings: {
      custom_image_url: emailHeaderBackgroundImage || BROKER_DEFAULT_EMAIL_HEADER_BANNER_IMAGE_URL
    },
    content_settings: {
      official_website: emailOfficialWebsite,
      book_meeting_address: emailBookMeetingAddress,
      contact_email_address: emailContactEmailAddress,
      contact_phone_number: emailContactPhoneNumber
    }
  };
};
export var convertLocalTripartiteCooperationQuoteSettingsDataToServerStructureData = function convertLocalTripartiteCooperationQuoteSettingsDataToServerStructureData(data, config) {
  var bankTransferAccountCountry = data.bankTransferAccountCountry,
      bankTransferBankName = data.bankTransferBankName,
      bankTransferBankBranchAddress = data.bankTransferBankBranchAddress,
      bankTransferAccountName = data.bankTransferAccountName,
      bankTransferAccountNumber = data.bankTransferAccountNumber,
      bankTransferSortCode = data.bankTransferSortCode,
      bankTransferIBAN = data.bankTransferIBAN,
      bankTransferNIB = data.bankTransferNIB,
      bankTransferSWIFT = data.bankTransferSWIFT,
      firstPaymentDelayedInceptionDate = data.firstPaymentDelayedInceptionDate,
      monthlyPaymentMinAmount = data.monthlyPaymentMinAmount,
      disabledPaymentMethods = data.disabledPaymentMethods,
      premiumOverrideMinAmountType = data.premiumOverrideMinAmountType,
      premiumOverrideMinAmount = data.premiumOverrideMinAmount,
      brokerPortalPaymentBillType = data.brokerPortalPaymentBillType,
      acturisPaymentBillType = data.acturisPaymentBillType,
      landingPagePaymentBillType = data.landingPagePaymentBillType,
      quoteTaxNumberMustBeFilledIn = data.quoteTaxNumberMustBeFilledIn,
      quoteDisclaimerEnabled = data.quoteDisclaimerEnabled,
      quoteDisclaimerHighlightText = data.quoteDisclaimerHighlightText,
      quoteDisclaimerContent = data.quoteDisclaimerContent,
      useEnglishWhenAccessingQuoteFirstTime = data.useEnglishWhenAccessingQuoteFirstTime,
      quoteHideBrokerFee = data.quoteHideBrokerFee,
      quoteWebsiteBodyBackgroundColor = data.quoteWebsiteBodyBackgroundColor,
      quoteShowAgreementCheckbox = data.quoteShowAgreementCheckbox,
      quoteHideBusinessRegistrationNumber = data.quoteHideBusinessRegistrationNumber,
      disablePolicyRenewal = data.disablePolicyRenewal,
      quoteExitRedirectUrl = data.quoteExitRedirectUrl,
      quoteHeaderLogoUrl = data.quoteHeaderLogoUrl,
      quoteHeaderLogoId = data.quoteHeaderLogoId,
      quoteHeaderBackgroundColor = data.quoteHeaderBackgroundColor,
      quoteHeaderLogoHeight = data.quoteHeaderLogoHeight;
  return {
    payment_settings: {
      quotes_from_broker_portal: brokerPortalPaymentBillType,
      quotes_from_acturis: acturisPaymentBillType,
      quotes_from_landing_page: landingPagePaymentBillType,
      first_payment_delayed_inception_date: firstPaymentDelayedInceptionDate,
      monthly_payment_min_amount: !monthlyPaymentMinAmount && monthlyPaymentMinAmount !== 0 ? null : monthlyPaymentMinAmount,
      disabled_payment_methods: disabledPaymentMethods || [],
      premium_override_min_amount_type: premiumOverrideMinAmountType || null,
      premium_override_min_amount: !premiumOverrideMinAmountType || !premiumOverrideMinAmount && premiumOverrideMinAmount !== 0 ? null : premiumOverrideMinAmount
    },
    bank_transfer_info: {
      account_country: bankTransferAccountCountry,
      bank_name: bankTransferBankName,
      bank_branch_address: bankTransferBankBranchAddress,
      account_name: bankTransferAccountName,
      account_number: bankTransferAccountNumber,
      sort_code: bankTransferSortCode,
      iban: bankTransferIBAN,
      nib: bankTransferNIB,
      swift: bankTransferSWIFT
    },
    quote_process_settings: {
      tax_number_must_be_filled: quoteTaxNumberMustBeFilledIn,
      quote_disclaimer_enabled: quoteDisclaimerEnabled,
      quote_disclaimer_highlight_text: quoteDisclaimerHighlightText,
      quote_disclaimer_content: quoteDisclaimerContent,
      use_english_when_accessing_quote_first_time: useEnglishWhenAccessingQuoteFirstTime,
      hide_broker_fee: quoteHideBrokerFee,
      quote_website_body_background_color: quoteWebsiteBodyBackgroundColor,
      show_agreement_checkbox: quoteShowAgreementCheckbox,
      hide_business_registration_number: quoteHideBusinessRegistrationNumber,
      disable_policy_renewal: disablePolicyRenewal,
      quote_exit_redirect_url: quoteExitRedirectUrl || '',
      // Quote header branding, edited on the branding page but written back here so that
      // saving the quote settings does not wipe the whole `quote_process_settings` bucket
      quote_header_logo_url: quoteHeaderLogoUrl || null,
      quote_header_logo_id: quoteHeaderLogoId || null,
      quote_header_background_color: quoteHeaderBackgroundColor || null,
      // The number input can hand back a string, normalise it so the stored value is always a number
      quote_header_logo_height: quoteHeaderLogoHeight || quoteHeaderLogoHeight === 0 ? Number(quoteHeaderLogoHeight) : null
    }
  };
};
export var convertLocalTripartiteCooperationProductLandingPageStatusDataToServerStructureData = function convertLocalTripartiteCooperationProductLandingPageStatusDataToServerStructureData(data, config) {
  var needConfigLandingPage = data.needConfigLandingPage,
      landingPageCollectDataSource = data.landingPageCollectDataSource,
      landingPageSourceDomain = data.landingPageSourceDomain,
      landingPageSourceUserName = data.landingPageSourceUserName,
      landingPageSourcePassword = data.landingPageSourcePassword,
      landingPageSourceEmailSenderInfo = data.landingPageSourceEmailSenderInfo;
  return {
    landing_page_status_config: {
      need_config_landing_page: needConfigLandingPage === truelyValueMap.yes.value ? true : false,
      landing_page_collect_data_source: landingPageCollectDataSource || '',
      landing_page_source_domain: landingPageSourceDomain || '',
      landing_page_source_user_name: landingPageSourceUserName || '',
      landing_page_source_password: landingPageSourcePassword || '',
      landing_page_source_email_sender_info: landingPageSourceEmailSenderInfo || ''
    }
  };
};

var toSubBrokerPortalServerListItem = function toSubBrokerPortalServerListItem(item) {
  var _ref = item !== null && item !== void 0 ? item : {},
      id = _ref.id,
      iconName = _ref.iconName,
      imageUrl = _ref.imageUrl,
      rest = _objectWithoutProperties(_ref, _excluded);

  return _objectSpread(_objectSpread(_objectSpread({}, rest), iconName !== undefined ? {
    icon_name: iconName || ''
  } : {}), imageUrl !== undefined ? {
    image_url: imageUrl || ''
  } : {});
};

var convertSubBrokerPortalCountryConfigDataToServerStructureData = function convertSubBrokerPortalCountryConfigDataToServerStructureData(data) {
  var brokerName = data.brokerName,
      heroHidden = data.heroHidden,
      heroDisplayType = data.heroDisplayType,
      heroTitle = data.heroTitle,
      heroSubtitle = data.heroSubtitle,
      heroChecklist = data.heroChecklist,
      heroImageUrl = data.heroImageUrl,
      coverageHidden = data.coverageHidden,
      coverageDisplayType = data.coverageDisplayType,
      coverageTitle = data.coverageTitle,
      coverageSubtitle = data.coverageSubtitle,
      coverageItems = data.coverageItems,
      expertiseHidden = data.expertiseHidden,
      expertiseDisplayType = data.expertiseDisplayType,
      expertiseTitle = data.expertiseTitle,
      expertiseChips = data.expertiseChips,
      portalHidden = data.portalHidden,
      portalDisplayType = data.portalDisplayType,
      portalTitle = data.portalTitle,
      portalFeatures = data.portalFeatures,
      advantageHidden = data.advantageHidden,
      advantageDisplayType = data.advantageDisplayType,
      advantageTitle = data.advantageTitle,
      advantageItems = data.advantageItems,
      ctaHidden = data.ctaHidden,
      ctaDisplayType = data.ctaDisplayType,
      ctaTitle = data.ctaTitle,
      ctaSubtitle = data.ctaSubtitle,
      resourcesHidden = data.resourcesHidden,
      resourcesDisplayType = data.resourcesDisplayType,
      resourcesTitle = data.resourcesTitle,
      resourcesSubtitle = data.resourcesSubtitle,
      resourceItems = data.resourceItems,
      faqHidden = data.faqHidden,
      faqDisplayType = data.faqDisplayType,
      faqTitle = data.faqTitle,
      faqItems = data.faqItems;

  var withoutItemId = function withoutItemId(list) {
    return (list || []).map(toSubBrokerPortalServerListItem);
  };

  return _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({
    broker_name: brokerName || '',
    hero_hidden: !!heroHidden,
    hero_display_type: heroDisplayType || 'default'
  }, heroDisplayType === 'custom' ? {
    hero_title: heroTitle || '',
    hero_subtitle: heroSubtitle || '',
    hero_checklist: (heroChecklist || []).map(function (item) {
      return (item === null || item === void 0 ? void 0 : item.text) || '';
    }),
    hero_image_url: heroImageUrl || ''
  } : {}), {}, {
    coverage_hidden: !!coverageHidden,
    coverage_display_type: coverageDisplayType || 'default'
  }, coverageDisplayType === 'custom' ? {
    coverage_title: coverageTitle || '',
    coverage_subtitle: coverageSubtitle || '',
    coverage_items: withoutItemId(coverageItems)
  } : {}), {}, {
    expertise_hidden: !!expertiseHidden,
    expertise_display_type: expertiseDisplayType || 'default'
  }, expertiseDisplayType === 'custom' ? {
    expertise_title: expertiseTitle || '',
    expertise_chips: withoutItemId(expertiseChips)
  } : {}), {}, {
    portal_hidden: !!portalHidden,
    portal_display_type: portalDisplayType || 'default'
  }, portalDisplayType === 'custom' ? {
    portal_title: portalTitle || '',
    portal_features: withoutItemId(portalFeatures)
  } : {}), {}, {
    advantage_hidden: !!advantageHidden,
    advantage_display_type: advantageDisplayType || 'default'
  }, advantageDisplayType === 'custom' ? {
    advantage_title: advantageTitle || '',
    advantage_items: withoutItemId(advantageItems)
  } : {}), {}, {
    cta_hidden: !!ctaHidden,
    cta_display_type: ctaDisplayType || 'default'
  }, ctaDisplayType === 'custom' ? {
    cta_title: ctaTitle || '',
    cta_subtitle: ctaSubtitle || ''
  } : {}), {}, {
    resources_hidden: !!resourcesHidden,
    resources_display_type: resourcesDisplayType || 'default'
  }, resourcesDisplayType === 'custom' ? {
    resources_title: resourcesTitle || '',
    resources_subtitle: resourcesSubtitle || '',
    resource_items: withoutItemId(resourceItems)
  } : {}), {}, {
    faq_hidden: !!faqHidden,
    faq_display_type: faqDisplayType || 'default'
  }, faqDisplayType === 'custom' ? {
    faq_title: faqTitle || '',
    faq_items: withoutItemId(faqItems)
  } : {});
};

export var convertLocalTripartiteCooperationSubBrokerPortalDataToServerStructureData = function convertLocalTripartiteCooperationSubBrokerPortalDataToServerStructureData(data) {
  var activated = data.activated,
      countries = data.countries,
      countryConfig = data.countryConfig;
  var countryList = (countries || []).filter(function (code) {
    return !!code;
  });
  return {
    sub_broker_portal_settings: _objectSpread({
      activated: !!activated,
      countries: countryList
    }, countryList.reduce(function (countrySettingsMap, code) {
      if (countryConfig !== null && countryConfig !== void 0 && countryConfig[code]) {
        countrySettingsMap[code] = convertSubBrokerPortalCountryConfigDataToServerStructureData(countryConfig[code]);
      }

      return countrySettingsMap;
    }, {}))
  };
};
export var convertLocalTripartiteCooperationSubBrokerPortalLoginIntroDataToServerStructureData = function convertLocalTripartiteCooperationSubBrokerPortalLoginIntroDataToServerStructureData(data) {
  var loginIntroDisplayType = data.loginIntroDisplayType,
      loginIntroTitle = data.loginIntroTitle,
      loginIntroList = data.loginIntroList;
  return _objectSpread({
    login_intro_display_type: loginIntroDisplayType || 'default'
  }, loginIntroDisplayType === 'custom' ? {
    login_intro_title: loginIntroTitle || '',
    login_intro_list: (loginIntroList || []).map(toSubBrokerPortalServerListItem)
  } : {});
};